import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Tab, 
  Nav,
  Container,
  Dropdown,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";
import CustomToggle from "../../../components/dropdowns";
import ShareOffcanvas from "../../../components/share-offcanvas";
import { MuiFileInput } from "mui-file-input";
// import {Row, Col, Container, Form, Button, Image} from 'react-bootstrap'
import moment from "moment";
//image
import user1 from "../../../assets/images/user/1.jpg";
import user01 from "../../../assets/images/user/01.jpg";
import user2 from "../../../assets/images/user/02.jpg";
import user3 from "../../../assets/images/user/03.jpg";
import user4 from "../../../assets/images/user/04.jpg";
import img1 from "../../../assets/images/small/07.png";
import img2 from "../../../assets/images/small/08.png";
import img3 from "../../../assets/images/small/09.png";
import img4 from "../../../assets/images/small/10.png";
import img5 from "../../../assets/images/small/11.png";
import img6 from "../../../assets/images/small/12.png";
import img7 from "../../../assets/images/small/13.png";
import img8 from "../../../assets/images/small/14.png";
import p1 from "../../../assets/images/page-img/p1.jpg";
import s1 from "../../../assets/images/page-img/s1.jpg";
import s2 from "../../../assets/images/page-img/s2.jpg";
import s3 from "../../../assets/images/page-img/s3.jpg";
import s4 from "../../../assets/images/page-img/s4.jpg";
import s5 from "../../../assets/images/page-img/s5.jpg";
import p2 from "../../../assets/images/page-img/p2.jpg";
import p3 from "../../../assets/images/page-img/p3.jpg";
import p4 from "../../../assets/images/page-img/p4.jpg";
import p5 from "../../../assets/images/page-img/p5.jpg";
import img42 from "../../../assets/images/page-img/42.png";
import icon1 from "../../../assets/images/icon/01.png";
import icon2 from "../../../assets/images/icon/02.png";
import icon3 from "../../../assets/images/icon/03.png";
import icon4 from "../../../assets/images/icon/04.png";
import icon5 from "../../../assets/images/icon/05.png";
import icon6 from "../../../assets/images/icon/06.png";
import icon7 from "../../../assets/images/icon/07.png";
import img9 from "../../../assets/images/small/img-1.jpg";
import img10 from "../../../assets/images/small/img-2.jpg";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "./Style.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getToken } from "../../../utils/auth";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../utils/useAuth";
import Sponsored from "../Sponsored";
import { MdOutlineDone } from "react-icons/md";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { CiGlobe } from "react-icons/ci";
import { BsPatchCheckFill } from "react-icons/bs";
import Sponsored1 from "../Sponsored1";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Context/UserContext";
import { CircularProgress } from "@mui/material";
import { Country, State } from 'country-state-city';

const Entertainment = () => {
  useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [loadingFull, setLoadingFull] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country:"",
    entertainmentCategory: "",
    openingTime: "",
    duration: "",
    rating: "",
    additionalInfo: "",
    websiteLink: "",
  });
  const [countryName, setCountryName] = useState("")

  const [showModal, setShowModal] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    email: '',
    phone: ''
  });
const getCountryCodeByName = (countryName) => {
  const country = Country.getAllCountries().find(
    (c) => c.name === countryName
  );
  return country?.isoCode || "";
};
  const handleOpenModal = (data) => {
    setContactInfo({
      email: data?.email,
      phone: data?.mobile
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  // const [hasMore, setHasMore] = useState(true);
  const [entertainment, setEntertainment] = useState([]);
  const [entries, setEntries] = useState("");
  const [postType, setPostType] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  const handleAllPost = async (reset = false) => {
    try {
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/post/category/all?page=${page}&limit=5&category=entertainment`;
      if (postType) {
        url += `&searchFor=${postType}&country=${countryName}`;
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (reset) {
        setEntertainment(response.data.data.allPosts);
        // console.log("TOTALPAGE",response.data.data.noOfEntries%5===0?response.data.data.noOfEntries/5:parseInt(response.data.data.noOfEntries/5)+1)
        } else {
          setEntertainment((prevPost) => [...prevPost, ...response.data.data.allPosts]);
          }
        setTotalPages(response.data.data.noOfEntries%5===0?response.data.data.noOfEntries/5:parseInt(response.data.data.noOfEntries/5)+1);
    } catch (error) {
      console.log("Failed Fetching Entertainment", error);
    }
  };

  // useEffect(() => {
  //   handleAllPost(true);
  // }, [postType]);

  useEffect(() => {
    if(page===1)
      {
        handleAllPost(true)
      }else{
        handleAllPost();
      }
  }, [page,postType]);

  const [upcoming, setUpcoming] = useState([]);
  const handleUpcoming = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );

      setUpcoming(response.data.data.allEvents);
    } catch (error) {
      console.log("Failed Fetching Upcoming Event", error);
    }
  };

  useEffect(() => {
    handleUpcoming();
  }, []);

 
   const handleVisitCount = async () => {
    try {
        const token = getToken();
        const response = await axios.post(
            `${process.env.REACT_APP_URL}/api/stats/module`,
            {
                moduleType: "deals"
            }, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }
        );
        
    } catch (error) {
        console.error('Failed Visit count', error);
    }

}
useEffect(()=>{
    handleVisitCount();
},[])

    const [imagePreview, setImagePreview] = useState(null);

    const handleFileInputChange = (event) => {
      const files = Array.from(event.target.files);
      setSelectedFile(files);
      const previews = files.map(file => URL.createObjectURL(file));
      setImagePreview(previews);
      toast.success("File selected!");
  };

  // const handleFileInputChange = (event) => {
  //   setSelectedFile([...event.target.files]);
  //   toast.success("File selected!");
  // };
  const [inputValue, setInputValue] = useState("");
  const [strings, setStrings] = useState([]);
  const handleAdd = (e) => {
    e.preventDefault();
    const text = inputValue.trim();
    if (text) {
      setStrings([...strings, text]);
      setInputValue("");
    } else {
      toast.error("Please enter some text.");
    }
  };
  
  const handleRemove = (index) => {
  const updatedList = strings.filter((_, i) => i !== index);
  setStrings(updatedList);
};
  const [photos, setPhotos] = useState([]);
  const handlePost = async () => {
    const MAX_SIZE = 1 * 1024 * 1024;
    for (let i = 0; i < selectedFile.length; i++) {
      if (selectedFile[i].size > MAX_SIZE) {
        toast.error(`File size must not exceed 1MB`);
        return;
      }
    }
    if (
      !formData.title ||
      !description ||
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.zipCode ||
      !formData.entertainmentCategory ||
      !formData.openingTime ||
      !formData.duration ||
      !selectedFile
    ) {
      toast.error("Please fill required fields");
      return;
    }
          if (selectedFile.length === 0) {
    toast.error("Please select at least one image.");
    return;
  }
    try {
      setLoadingFull(true)
const token = getToken();
      const formData = new FormData();
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("files", selectedFile[i]);
      }

      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("oath", uploadResponse.data.data);

      setPhotos(uploadResponse.data.data);
      postPhoto(uploadResponse.data.data);

      //   setShow(false);
    } catch (error) {
      console.log("Failed to create post:", error);
      toast.error(
        error?.uploadResponse?.data?.message || "Failed to Upload Image/Video"
      );
    } finally{
      setLoadingFull(false)

    }
  };

  const postPhoto = async (photoss) => {
    if (
      !formData.title ||
      !description ||
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.zipCode ||
      !formData.entertainmentCategory ||
      !formData.openingTime ||
      !formData.duration 
    ) {
      toast.error("Please fill required fields");
      return;
    }

    try {
      setLoadingFull(true)
const token = getToken();
      const postData = {
        title: formData.title,
        description: description,
        location: {
          address: formData.address,
          city: formData.city,
          state: formData.state,
          zipCode: formData.zipCode,
          country: formData.country
        },
                entertainmentCategory: formData.entertainmentCategory,
        openingTime: formData.openingTime,
        duration: formData.duration,
        rating: formData.rating,
        websiteLink: formData.websiteLink,
        reviews: strings,
        additionalInfo: formData.additionalInfo,
        photos: photoss,
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/entertainment`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleAllPost(true);
      toast.success("Post created successfully");
      setDescription("");
      setSelectedFile([]);
      setStrings([]);
      setFormData({
        title: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
                entertainmentCategory: "",
        openingTime: "",
        duration: "",
        rating: "",
        additionalInfo: "",
        websiteLink:""
      });
      //   setShow(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("Failed Posting ", error);
    } finally {
      setShow(false);
      setLoadingFull(false)

    }
  };


  const [sponsoredAd, setSponsoredAd] = useState([]);
  const handleSponsored = async () => {
    try {
        const token = getToken();
        const response = await axios.get(
            `${process.env.REACT_APP_URL}/api/ad/all/ads`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const adData = response.data.data.adData;
        const activeAd = adData.find(ad => ad.status === "Active");

        if (activeAd) {
            setSponsoredAd(activeAd);
        } else {
            console.log("No Active Sponsored Ads Found");
        }
    } catch (error) {
        console.log("Failed Fetching Sponsored Ads", error);
    }
};


  useEffect(() => {
    handleSponsored();
  }, []);

  const [user, setUser] = useState("");

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("user details header", response.data.data);
      setUser(response?.data?.data);
      const countryCode = response?.data?.data?.country || "";
                  const countryInfo = Country.getCountryByCode(countryCode);
                  const countryNameFromList = countryInfo?.name || "";
                  setCountryName(countryNameFromList)
                  setFormData((prev) => ({ ...prev, country: countryNameFromList }));
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  useEffect(() => {
      fetchUserData();
  },[])

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const loadMore = () => {
    setPage(page + 1);
};

const { userData } = useUser();
  const profileImage = userData?.profileImageLink ? userData?.profileImageLink : "/profile.png";

const [dropdown, setDropdown] = useState();

const handleDropdown = async () => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/api/default-setting/values?getFeild=entertainmentCategory`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Category Dropdown fetched", response.data.data.defaultData.entertainmentCategory);
    setDropdown(response.data.data.defaultData.entertainmentCategory);
  } catch (error) {
    console.error("Failed Fetching dropdown", error);
  }
};
useEffect(()=>{
handleDropdown();
},[]);

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}

<div id="content-page" className="content-page">
        <Container>
          <Row>
          <Col lg="12">
              <Tab.Container defaultActiveKey="f1">
                <Card className="cardnavbar">
                  <div className="user-tabing">
                    <Nav
                                         variant="pills"
                                         className="connection-tabs-nav p-0 m-0 round"
                                       >
                                         <Nav.Item as="li">
                                           <Nav.Link
                                             onClick={(e) => {
                                               setPostType("");
                                               setPage(1);
                                             }}
                                             className="text-center"
                                             eventKey="f1"
                                             href="#"
                                           >
                                             {t("my_posts")}
                                           </Nav.Link>
                                         </Nav.Item>
                   
                                         <Nav.Item as="li">
                                           <Nav.Link
                                             onClick={(e) => {
                                               setPostType("all");
                                               setPage(1);
                                             }}
                                             className="text-center"
                                             eventKey="f2"
                                             href="#"
                                           >
                                             {t("other_posts")}
                                           </Nav.Link>
                                         </Nav.Item>
                                       </Nav>
                  </div>
                </Card>
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="f1">
                  <Col lg={12} className="row m-0 p-0">
              <Col sm={12}>
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">{t('createPostEntertainment')}</h4>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="d-flex align-items-center">
                      <div className="user-img">
                        <img
                        src={profileImage}
                          // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                          alt="user1"
                          className="avatar-60 rounded-circle"
                        />
                      </div>
                      <form
                        className="post-text ms-3 w-100 "
                        onClick={handleShow}
                      >
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder={t('writeSomethingHere')}
                          style={{ border: "none" }}
                        />
                      </form>
                    </div>
                   
                  </Card.Body>
                  <Modal
                    size="lg"
                    className="fade"
                    id="post-modal"
                    onHide={handleClose}
                    show={show}
                    style={{ marginTop: "100px", maxHeight: "80vh" }}
                  >
                    <Modal.Header className="d-flex justify-content-between">
                      <Modal.Title id="post-modalLabel">
                        {t('createPostEntertainment')}
                      </Modal.Title>
                      <Link to="#" className="lh-1" onClick={handleClose}>
                        <span className="material-symbols-outlined">close</span>
                      </Link>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center">
                        {/* <div className="user-img">
                                                    <img src={profileImage} alt="user1" className="avatar-60 rounded-circle img-fluid" />
                                                </div> */}
                        <form
                          className="post-text ms-3 w-100 "
                          data-bs-toggle="modal"
                          data-bs-target="#post-modal"
                        >
                          {/* <input type="text" className="form-control rounded" placeholder="What's on your mind?" style={{border:"none"}} onChange={(e)=> setDescription(e.target.value)}/> */}
                          {/* <EmojiPicker /> */}
                          {/* <br /> */}
                        </form>
                      </div>
                      {/* <hr /> */}
                      <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('title')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              value={formData.title}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enterTitle')}
                              required
                            />
                          </Form.Group>
                        </li>

                        <li className="col-12 mb-3">
                          <Form.Label>
                            {t('description')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <CKEditor
                            editor={ClassicEditor}
                            data=""
                                config={{
    toolbar: [
      'heading', '|',
      'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
      'undo', 'redo'
    ],
    removePlugins: ['ImageUpload', 'MediaEmbed', 'EasyImage'],
          placeholder: t('whats_on_your_mind'),

  }}
                             onChange={(event, editor) => {
                              const data = editor.getData();
                              setDescription(data);
                            }}
                          />
                        </li>
                                               <li className="col-12 mb-1 ">
                                                 <Form.Group className="form-group">
                                                   <Form.Label>
                                                     {t('address')} <span style={{ color: "red" }}>*</span>{" "}
                                                   </Form.Label>
                                                   <Form.Control
                                                     type="text"
                                                     name="address"
                                                     value={formData.address}
                                                     onChange={handleChange}
                                                     className="mb-0 py-2"
                                                     id=""
                                                     placeholder={t('address')}
                                                     required
                                                   />
                                                 </Form.Group>
                                               </li>
                                             
                                               <li className="col-12 m-0 p-0">
                         <div className="row col-12 p-0 m-0">
                           <div className="col-6 p-0 pe-2 m-0">
                             <Form.Group className="form-group">
                               <Form.Label>
                                 {t("country")} <span style={{ color: "red" }}>*</span>{" "}
                               </Form.Label>
                               <Form.Select
                                 name="country"
                                 value={formData.country}
                                 onChange={(e) => {
                                   const selectedCountryName = e.target.value;
                                   setFormData({
                                     ...formData,
                                     country: selectedCountryName,
                                     state: "",
                                   });
                                 }}
                                 className="mb-0 py-2"
                                 required
                               >
                                 <option value="">{t("selectCountry")}</option>
                                 {Country.getAllCountries().map((country) => (
                                   <option key={country.isoCode} value={country.name}>
                                     {country.name}
                                   </option>
                                 ))}
                               </Form.Select>
                             </Form.Group>
                           </div>
                       
                           <div className="col-6 p-0 m-0">
                             <Form.Group className="form-group">
                               <Form.Label>
                                 {t("state")} <span style={{ color: "red" }}>*</span>{" "}
                               </Form.Label>
                               <Form.Select
                                 name="state"
                                 value={formData.state}
                                 onChange={handleChange}
                                 className="mb-0 py-2"
                                 required
                                 disabled={!formData.country}
                               >
                                 <option value="">{t("selectState")}</option>
                                 {formData.country &&
                                   State.getStatesOfCountry(getCountryCodeByName(formData.country)).map(
                                     (state) => (
                                       <option key={state.isoCode} value={state.name}>
                                         {state.name}
                                       </option>
                                     )
                                   )}
                               </Form.Select>
                             </Form.Group>
                           </div>
                         </div>
                       </li>
                       
                       
                                               <li className="col-12 m-0 p-0 ">
                                               <div className="row col-12 p-0 m-0 " >
                         <div className="col-6 p-0 pe-2 m-0 ">
                         
                           <Form.Group className="form-group">
                                                   <Form.Label>
                                                     {t('city')} <span style={{ color: "red" }}>*</span>{" "}
                                                   </Form.Label>
                                                   <Form.Control
                                                     type="text"
                                                     name="city"
                                                     value={formData.city}
                                                     onChange={handleChange}
                                                     className="mb-0 py-2"
                                                     id=""
                                                     placeholder={t('city')}
                                                     required
                                                   />
                                                 </Form.Group>
                         </div>
                         <div className="col-6 p-0 m-0">
                           <Form.Group className="form-group">
                             <Form.Label>
                               {t('pincode')} <span style={{ color: "red" }}>*</span>{" "}
                             </Form.Label>
                             <Form.Control
                               type="text"
                               name="zipCode"
                               value={formData.zipCode}
                               onChange={(e) => {
                                 const re = /^[0-9]{0,6}$/;
                                 if (re.test(e.target.value)) {
                                   setFormData(prevState => ({
                                     ...prevState,
                                     zipCode: e.target.value
                                   }));
                                 }
                               }}
                               className="mb-0 py-2"
                               placeholder={t('pincode')}
                               required
                             />
                           </Form.Group>
                         </div>
                       </div>
                       
                                             </li>
                        <li className="col-6 pe-2 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                            {t('entertainmentCategory')}{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                                       <Form.Control
                            as="select"
                            name="entertainmentCategory"
                            value={formData.entertainmentCategory}
                            onChange={handleChange}
                            className="mb-0 py-2"
                            required
                          >
                            <option value="">{t('select_a_category')}</option>
                            {dropdown?.map((category, index) => (
                              <option key={index} value={category}>
                                {category}
                              </option>
                            ))}
                          </Form.Control>
                          </Form.Group>
                        </li>
                                                <li className="col-6 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                            {t('rating')} 
                            </Form.Label>
                            <Form.Control
                              type="tel"
                              maxLength={1}
                              name="rating"
                              value={formData.rating}
                              onChange={(e) => {
                                const re = /^[0-9\b]+$/;
                                if (
                                  e.target.value === "" ||
                                  re.test(e.target.value)
                                ) {
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    rating: e.target.value,
                                  }));
                                }
                              }}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enterRating')}
                              required
                            />
                          </Form.Group>
                        </li>
                        <li className="col-6 pe-2 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                            {t('openingTime')}{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              type="datetime-local"
                              name="openingTime"
                              value={formData.openingTime}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enterOpeningTime')}
                              required
                              min={getCurrentDateTime()}
                              onFocus={(e) => e.target.showPicker()}
                            />
                          </Form.Group>
                        </li>
                        <li className="col-6 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('duration')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>

                            <Form.Control
                              type="text"
                              name="duration"
                              value={formData.duration}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enterDuration')}
                              required
                            />
                          </Form.Group>
                        </li>

                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                            {t('additionalInfo')}{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="additionalInfo"
                              value={formData.additionalInfo}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enterAdditionalInfo')}
                              required
                            />
                          </Form.Group>
                        </li>
                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('website_link')}{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="websiteLink"
                              value={formData.websiteLink}
                            onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enter_website_link')}
                              required
                            />
                          </Form.Group>
                        </li>
                        {/* <li className="col-md-12 mb-1 ">
                        <Form.Group className="form-group">
      <Form.Label>
      {t('reviews')}
      </Form.Label>
      <div className="d-flex">
        <form
          onSubmit={handleAdd}
          style={{
            gap: "10px",
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <Form.Control
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className="mb-0 py-2"
            style={{ width: "80%" }}
            placeholder={t('enterReviews')}
            required
          />
          <button
            type="submit"
            style={{ width: "20%" }}
            className="btn btn-secondary ml-2"
          >
            {t('add')}
          </button>
        </form>
      </div>
    </Form.Group>
    {strings.length > 0 && (
        <ul style={{maxHeight:"200px", overflowY:"auto", border:"1px solid #d4d4d4", borderRadius:"10px", display:"flex", flexDirection:"column"}}>
          {strings.map((str, index) => (
            <li key={index}>{str}</li>
          ))}
        </ul>)}
                        </li> */}
                        <li className="col-md-12 mb-1">
  <Form.Group className="form-group">
    <Form.Label>{t('reviews')}</Form.Label>

    <div className="d-flex">
      <form
        onSubmit={handleAdd}
        style={{
          gap: "10px",
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <Form.Control
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="mb-0 py-2"
          style={{ width: "80%" }}
          placeholder={t('enterReviews')}
          required
        />

        <button
          type="submit"
          style={{ width: "20%" }}
          className="btn btn-secondary ml-2"
        >
          {t('add')}
        </button>
      </form>
    </div>
  </Form.Group>

  {strings.length > 0 && (
    <ul
      style={{
        maxHeight: "200px",
        overflowY: "auto",
        // border: "1px solid #d4d4d4",
        borderRadius: "10px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {strings.map((str, index) => (
        <li
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f8f8f8",
            padding: "8px",
            borderRadius: "6px",
          }}
        >
          <span>{str}</span>

          <button
            className="btn btn-danger btn-sm" style={{textTransform:"capitalize"}}
            onClick={() => handleRemove(index)}
          >
            {t('remove')}
          </button>
        </li>
      ))}
    </ul>
  )}
</li>

                        <li className="col-md-12 mb-1">
                          <Form.Label>
                          {t('image')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <label
                            htmlFor="file-input"
                            style={{ cursor: "pointer", width: "100%" }}
                          >
                            <div
                              className="bg-soft-primary rounded p-1 pointer"
                              style={{
                                width: "100%",
                                textAlign: "center",
                                fontSize: "1.2rem",
                                position: "relative",
                                borderRadius: "10px",
                              }}
                            >
                              <input
                                id="file-input"
                                type="file"
                                name="image"
                                multiple
                                style={{ display: "none" }}
                                onChange={handleFileInputChange}
                              />
                              <span>
                                {selectedFile.length > 0 ? (
                                  <MdOutlineDone style={{ fontSize: "25px" }} />
                                ) : (
                                  <i className="fas fa-upload"></i>
                                )}
                              </span>
                              <p style={{ marginTop: ".5rem" }}>
                                {t('click_to_select_files')}
                              </p>
                            </div>
                          </label>
                          {imagePreview && imagePreview.length > 0 && (
                            <div className="mt-2">
                                {imagePreview.map((preview, index) => (
                                    <img key={index} src={preview} alt={`Selected ${index}`} style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }} />
                                ))}
                            </div>
                        )}
                        </li>
                      </ul>
                      {/* <hr /> */}

                      <button
                        type="submit"
                        className="btn btn-primary d-block w-100 mt-3"
                        onClick={handlePost}
                      >
                        {t('post')}
                      </button>
                    </Modal.Body>
                  </Modal>
                  <Modal
size="md" centered
className="fade"
show={showModal}
onHide={handleCloseModal}
style={{ marginTop: "100px", maxHeight: "80vh" }}
>
<Modal.Header className="d-flex justify-content-between">
  <Modal.Title id="post-modalLabel">
    {t('contact_information')}
  </Modal.Title>
</Modal.Header>
<Modal.Body>
  <div>
    {contactInfo.email && (
      <p>
        <strong>{t("email_label")}:</strong>
        <a href={`mailto:${contactInfo.email}`} style={{ textDecoration: 'none' }}>
          {contactInfo.email}
        </a>
        <CiMail 
          size={20} 
          style={{ marginRight: "5px", fontWeight: "600", marginLeft: "10px", cursor: "pointer" }} 
          onClick={() => window.location.href = `mailto:${contactInfo.email}`} 
        />
      </p>
    )}

    {contactInfo.phone && (
      <p>
        <strong>{t("phone_label")}:</strong>
        <a href={`tel:${contactInfo.phone}`} style={{ textDecoration: 'none' }}>
          {contactInfo.phone}
        </a>
        <IoCallOutline 
          size={18} 
          style={{ marginRight: "5px", marginLeft: "10px", cursor: "pointer" }} 
          onClick={() => window.location.href = `tel:${contactInfo.phone}`} 
        />
      </p>
    )}

    {!contactInfo.email && !contactInfo.phone && (
      <p>{t("contactInformationNotAvailable")}</p>
    )}
    <button
      type="button"
      className="btn btn-primary d-block w-100 mt-3"
      onClick={handleCloseModal}
    >
      {t('close')}
    </button>
  </div>
</Modal.Body>
</Modal>
                </Card>
              </Col>
              <Sponsored1 />
              <InfiniteScroll
              style={{overflowX:"hidden"}}
                dataLength={post.length}
                next={loadMore}
                hasMore={page<totalPages}
                loader={
                  <div className="col-sm-12 text-center">
                    <img
                      src={loader}
                      alt="loader"
                      style={{ height: "100px" }}
                    />
                  </div>
                }
                endMessage={entertainment?.length!==0 && (<p className="text-center">{t('no_more_posts')}</p>)}
              >
                {entertainment?.length === 0 ? (
                  <div>{t('no_posts_yet')}</div>
                ) : (
                  entertainment?.map((data, index) => (
                    <Col sm={12} key={index}>
                      <Card className=" card-block card-stretch card-height boxcard">
                        <Card.Body>
                          <div className="container_enter">
                            <div className="container_a">
                              <div style={{ display:"flex",width: "180px", minHeight: "180px", margin:"10px", width:"25%", alignItems:"center" }}>
                                <Carousel
                                  showArrows={false}
                                  showThumbs={false}
                                  showStatus={false}
                                  infiniteLoop
                                  autoPlay
                                  interval={2000}
                                >
                                  {data?.photos?.map((image) => (
                                    <div>
                                      <img
          src={image ? image : "/profile.png"}
          className="rounded image_enter"
          alt="Responsive"
          onError={(e) => { e.target.onerror = null; e.target.src = "/profile.png"; }}
        />
                                    </div>
                                  ))}
                                </Carousel>
                              </div>
                              <div style={{ flex: '1 1 45%', display: 'flex', flexDirection: 'column', margin: '10px'}}>
                                <h2 className="text-primary">{data?.title}</h2>
                                <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                                {data?.location ? (<span className="heading">{t('location')}: <span className="head">{data?.location?.address}, {data?.location?.city}, {data?.location?.state}, {data?.location?.country}, {data?.location?.zipCode}</span></span>): (<div></div>)}
                                <span className="heading">{t('duration')}: <span className="head">{data?.duration}</span></span>
                                  {data?.entertainmentCategory ? (<span className="heading">{t('category')}: <span className="head">{data?.entertainmentCategory}</span></span>) : (<div></div>)}
                                  {data?.additionalInfo ? (<span className="heading">{t('info')}: <span className="head">{data?.additionalInfo}</span></span>) : (<div></div>)}
                                  {data?.rating ? (<span className="heading">{t('rating')}: <span className="head">{data?.rating}</span></span>) : (<div></div>)}
                                  {data?.reviews && data.reviews.length > 0 && (
                <span className="heading">
                    {t('reviews')}: <span className="head">{data.reviews.join(', ')}</span>
                </span>
            )}
                              </div>
                              <div style={{ display:"flex", width:"30%", flexDirection:"column", borderLeft:"1px solid #d4d4d4",padding:"10px", height:"100%", background:"rgb(248,248,248)"}}>
                                <h4 className="" >{data?.userId?.firstName} {data?.userId?.lastName}<BsPatchCheckFill style={{color:"green", marginInline:"10px"}}/>
</h4>
                                {/* <div>Raja Garden, Delhi</div> */}
                                {data?.websiteLink && (

                                <span className="heading" style={{ display: "flex", color: "blue", marginBlock: "10px" }}>
        <a href={data?.websiteLink} target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
          <CiGlobe size={16} style={{ marginRight: "5px", marginTop: "-2px" }} />
          {t('website')}
        </a>
      </span> )} <div className="buttonsection">
      {/* <button className="buttonsend" onClick={()=>handleOpenModal(data?.contactInfo)}><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button> */}
  {/* <button className="buttonsend"><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button>
  <button className="constbutton"><IoCallOutline size={18} style={{marginRight:"5px"}}/>{t('contact')}</button> */}
</div>
                              </div>
                            </div>
                          </div> 
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                )}
              </InfiniteScroll>
            </Col>
                  </Tab.Pane>
                  <Tab.Pane eventKey="f2">
                  <Col lg={12} className="row m-0 p-0">
              <Col sm={12}>
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">{t('createPostEntertainment')}</h4>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="d-flex align-items-center">
                      <div className="user-img">
                        <img
                        src={profileImage}
                          // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                          alt="user1"
                          className="avatar-60 rounded-circle"
                        />
                      </div>
                      <form
                        className="post-text ms-3 w-100 "
                        onClick={handleShow}
                      >
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder={t('writeSomethingHere')}
                          style={{ border: "none" }}
                        />
                      </form>
                    </div>
                   
                  </Card.Body>
                 
                </Card>
              </Col>
              <Sponsored1 />
              <InfiniteScroll
              style={{overflowX:"hidden"}}
                dataLength={post.length}
                next={() => setPage((page) => page + 1)}
                hasMore={page<totalPages}
                                loader={
                  <div className="col-sm-12 text-center">
                    <img
                      src={loader}
                      alt="loader"
                      style={{ height: "100px" }}
                    />
                  </div>
                }
                endMessage={entertainment?.length!==0 && (<p className="text-center">{t('no_more_posts')}</p>)}
              >
                {entertainment?.length === 0 ? (
                  <div>{t('no_posts_yet')}</div>
                ) : (
                  entertainment?.map((data, index) => (
                    <Col sm={12} key={index}>
                      <Card className=" card-block card-stretch card-height boxcard">
                        <Card.Body>
                          <div className="container_enter">
                            <div className="container_a">
                              <div style={{ display:"flex",width: "180px", minHeight: "180px", margin:"10px", width:"25%", alignItems:"center" }}>
                                <Carousel
                                  showArrows={false}
                                  showThumbs={false}
                                  showStatus={false}
                                  infiniteLoop
                                  autoPlay
                                  interval={2000}
                                >
                                  {data?.photos?.map((image) => (
                                    <div>
                                      <img
          src={image ? image : "/profile.png"}
          className="rounded image_enter"
          alt="Responsive"
          onError={(e) => { e.target.onerror = null; e.target.src = "/profile.png"; }}
        />
                                    </div>
                                  ))}
                                </Carousel>
                              </div>
                              <div style={{ flex: '1 1 45%', display: 'flex', flexDirection: 'column', margin: '10px'}}>
                                <h2 className="text-primary">{data?.title}</h2>
                                <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                                  <span className="heading" style={{marginTop:"-10px"}}>{t('info')}: <span className="head">{data?.additionalInfo}</span></span>
                                  {data?.location ? (<span className="heading">{t('location')}: <span className="head">{data?.location?.address}, {data?.location?.city}, {data?.location?.state}, {data?.location?.country}, {data?.location?.zipCode}</span></span>): (<div></div>)}
                                  <span className="heading">{t('duration')}: <span className="head">{data?.duration}</span></span>
                                  <span className="heading">{t('rating')}: <span className="head">{data?.rating}</span></span>
                              </div>
                              <div style={{ display:"flex", width:"30%", flexDirection:"column", borderLeft:"1px solid #d4d4d4",padding:"10px", height:"100%", background:"rgb(248,248,248)"}}>
                                <h4 className="" >{data?.userId?.firstName} {data?.userId?.lastName}<BsPatchCheckFill style={{color:"green", marginInline:"10px"}}/>
</h4>
                                {/* <div>Raja Garden, Delhi</div> */}
                                <span className="heading" style={{display:"flex", color:"blue", marginBlock:"10px"}}><span ><CiGlobe size={16} style={{marginRight:"5px",marginTop:"-2px"}}/>{t('website')}</span></span>
                                <div className="buttonsection">
                                {/* <button className="buttonsend" onClick={()=>handleOpenModal(data?.contactInfo)}><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button> */}
  {/* <button className="buttonsend"><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button>
  <button className="constbutton"><IoCallOutline size={18} style={{marginRight:"5px"}}/>{t('contact')}</button> */}
</div>
                              </div>
                            </div>
                          </div> 
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                )}
              </InfiniteScroll>
            </Col>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
};
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default Entertainment;
